import "core-js/modules/web.dom-collections.iterator.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-18024744"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "pages-header-h5 d-flex justify-content-between align-items-center"
};
const _hoisted_2 = {
  class: "page-title"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("i", {
    class: "ico-arrow-left router-back",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.goBack && $setup.goBack(...args))
  }), _createElementVNode("div", _hoisted_2, _toDisplayString($props.title), 1), _renderSlot(_ctx.$slots, "right", {}, () => [_hoisted_3], true)]);
}